module.exports = __webpack_public_path__ + "img/uam.f64c5450.svg";